import { useEffect, useCallback, useMemo, Dispatch } from 'react';
import { useFlashTransition } from '__hooks/useFlashState';
import { VariableErrorTypes } from '../VariableWizardContext';
import { ValidationKeys } from './ValidationKeys';

export const useInputErrors = <Type extends string = ValidationKeys>(
  id: string,
  errorKey: Type,
  inputErrors: Record<Type, string[]>, //VariableErrorType,
  errors: VariableErrorTypes,
  setErrors: Dispatch<VariableErrorTypes>
) => {
  const [message, showMessage, flashErrorMessage, cancelFlash] =
    useFlashTransition();

  const variableError = (inputErrors || {})[errorKey];

  useEffect(() => {
    if (errorKey && variableError) {
      flashErrorMessage(variableError);
    }
  }, [variableError, flashErrorMessage, errorKey]);

  const { validate, hasError } = useMemo(
    () => ({
      validate: {
        showMessage,
        message,
        popperConfig: {
          modifiers: {
            preventOverflow: { enabled: false },
          },
        },
      },
      hasError: !!errorKey && variableError,
    }),
    [showMessage, message, errorKey, variableError]
  );

  const clearError = useCallback(
    (prop: Type) => {
      if (showMessage && errorKey === prop) {
        cancelFlash();
      }

      const { [id]: _, ...nextErrors } = errors;

      setErrors(nextErrors);
    },
    [cancelFlash, errorKey, errors, id, setErrors, showMessage]
  );

  return { validate, hasError, clearError };
};
